export default __webpack_public_path__ + "outro.6de0c5915653eff4b2dc7648d3927ca0.sha.mp4";